import React, { Component, PropTypes } from 'react';
import { emojify } from 'react-emojione';
import linkifier from 'react-linkifier';

import LiveMoment from '../LiveMoment';
import ButtonIcon from '../ButtonIcon';
import userPlaceholderImage from '../../images/userPlaceholder.svg';

import editIconImage from './editIcon.svg';

export default class StatusListItem extends Component {
  static propTypes = {
    onEdit: PropTypes.func.isRequired,
    showEdit: PropTypes.bool,
    status: PropTypes.shape({
      createdAt: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      username: PropTypes.string,
    }).isRequired,
    type: PropTypes.oneOf(['one-line', 'image', 'large']),
    user: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
    }),
  }

  static defaultProps = {
    user: {},
    showEdit: false,
    type: 'one-line',
  }

  render() {
    const {
      user: {
        image = userPlaceholderImage,
        name,
      },
      onEdit,
      showEdit,
      status: { createdAt, updatedAt, text, username },
      type,
    } = this.props;

    const isImage = type === 'image';
    const isLarge = type === 'large';

    const showEditedInline = isImage || isLarge;

    const emojifiedText = emojify(text, { output: 'unicode' });
    const emojifiedAndLinkifiedJSX = (
      <div
        className={`wb-bw f6 f5-ns lh-copy ${isImage ? 'dark-gray' : ''}`}
        style={{ whiteSpace: 'pre-wrap' }}
      >
        { linkifier(emojifiedText, { target: '_blank' }) }
        &nbsp;&nbsp;
        {showEditedInline && updatedAt &&
          <span className="gray">(edited)</span>
        }
        &nbsp;&nbsp;
        {showEdit &&
          <ButtonIcon
            iconImage={editIconImage}
            onClick={onEdit}
          >
            Edit
          </ButtonIcon>
        }
      </div>
    );
    const updatedOrCreatedAt = updatedAt || createdAt;

    const nameText = name || username;

    if (isImage || isLarge) {
      const userJSX = (
        <div>
          <div className="dtc w2">
            <img alt={nameText} className="br2" src={image} width="30px" />
          </div>
          <div className="dtc v-mid pl2">
            <div className="dark-gray f6">{nameText}</div>
            <LiveMoment className="f6 silver ttu fw1" date={updatedOrCreatedAt}>
              {m => <small>{m.twitterLong('ago')}</small>}
            </LiveMoment>
          </div>
        </div>
      );

      if (isImage) {
        return (
          <div className="mb4 mt3 mb3-ns mt0-ns flex flex-column dt-ns">
            <div className="mt2 mt3-ns w4 dtc-ns v-top-ns order-2">
              {userJSX}
            </div>
            <div className="dtc-ns pl5-ns f6 order-1">
              { emojifiedAndLinkifiedJSX }
            </div>
          </div>
        );
      } else if (isLarge) {
        return (
          <div className="mv4 pb4 bb b--black-10 relative">
            <div className="f4-ns f5">
              { emojifiedAndLinkifiedJSX }
            </div>
            <div className="mt3">
              {userJSX}
            </div>
          </div>
        );
      }
    }

    return (
      <div>
        <div className="f5">
          { emojifiedAndLinkifiedJSX }
        </div>
        <div className="mt2 silver f6">
          <span>
            { updatedAt ? 'edited by' : 'posted by' }&nbsp;
          </span>
          <span className="dark-gray">{nameText}</span>
          <LiveMoment className="ml2 ttu fw1" date={updatedOrCreatedAt}>
            {m => <small>{m.twitterLong('ago')}</small>}
          </LiveMoment>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/StatusListItem/index.jsx
 **/